import Model from './BaseModel'
import Role from './Role'
import i18n from '@/plugins/i18n'

export default class User extends Model {
    resourceName() {
        return 'users'
    }

    fields() {
        return ['id', 'name', 'email', 'password', 'password_confirmation']
    }

    relationships() {
        return {
            roles: new Role(),
        }
    }

    get searchable() {
        return ['name']
    }

    get tableColumns() {
        return [
            { text: i18n.t('user.table-texts.name'), value: 'name' },
            { text: i18n.t('user.table-texts.email'), value: 'email' },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }
}
